import type { LstWithdrawalRegistryEntry } from '../registry'
import { readerBeets } from './beets'
import { readerBeHype } from './behype'
import { readerBenqi } from './benqi'
import { readerBinanceWbeth } from './binance'
import { readerBeraPaw } from './berapaw'
import { readerEmpty } from './empty'
import { readerIbera } from './ibera'
import { readerPrimeStaking } from './primestaking'
import { readerErc7540 } from './erc7540'
import { readerEthenaCooldown } from './ethenaCooldown'
import { readerSusd3Cooldown } from './susd3'
import { readerStrataCooldown } from './strataCooldown'
import { readerEtherFi } from './etherfi'
import { readerKelp } from './kelp'
import { readerLido } from './lido'
import { readerLista } from './lista'
import { readerRenzo } from './renzo'
import { readerStaderEthx } from './staderEthx'
import { readerStaderMaticX } from './staderMaticx'
import { readerMantle } from './mantle'
import { readerPuffer } from './puffer'
import { readerKinetiq } from './kinetiq'
import { readerLair } from './lair'
import { readerStakeWise } from './stakewise'
import { readerStCelo } from './stcelo'
import { readerSwell } from './swell'
import { readerValantis } from './valantis'
import { readerTreehouseRedemption } from './treehouse'
import { readerTruFin } from './trufin'
import { readerYieldNest } from './yieldnest'
import type { LstWithdrawalReader } from './shared'

export type {
  LstWithdrawalReader,
  LstWithdrawalKnownId,
  LstWithdrawalKnownIds,
} from './shared'
export { computeStatus, toBigInt, toNumber } from './shared'

/** Dispatch a registry entry to its withdrawal reader. */
export const buildWithdrawalReader = (
  entry: LstWithdrawalRegistryEntry,
): LstWithdrawalReader => {
  switch (entry.reader) {
    case 'binanceWbethQueue':
      return readerBinanceWbeth
    case 'lidoQueue':
      return readerLido
    case 'etherfiNft':
      return readerEtherFi
    case 'yieldNestNft':
      return readerYieldNest
    case 'staderEthxQueue':
      return readerStaderEthx
    case 'staderMaticXQueue':
      return readerStaderMaticX
    case 'renzoQueue':
      return readerRenzo
    case 'kelpQueue':
      return readerKelp
    case 'benqiSavaxQueue':
      return readerBenqi
    case 'beetsStSQueue':
      return readerBeets
    case 'hyperbeatBeHype7540':
    case 'erc7540':
      return readerErc7540
    case 'ethenaCooldown':
      return readerEthenaCooldown
    case 'susd3Cooldown':
      return readerSusd3Cooldown
    case 'strataCooldown':
      return readerStrataCooldown
    case 'swellNft':
      return readerSwell
    case 'stakeWiseSubgraph':
      return readerStakeWise
    case 'mantleCallerSuppliedIds':
      return readerMantle
    case 'pufferCallerSuppliedIds':
      return readerPuffer
    case 'trufinCallerSuppliedIds':
      return readerTruFin
    case 'lairCallerSuppliedIds':
      return readerLair
    case 'stceloAccountQueue':
      return readerStCelo
    case 'kinetiqQueue':
      return readerKinetiq
    case 'beHypeQueue':
      return readerBeHype
    case 'valantisBurnQueue':
      return readerValantis
    case 'listaQueue':
      return readerLista
    case 'iberaQueue':
      return readerIbera
    case 'primeStakingQueue':
      return readerPrimeStaking
    case 'berapawRedeemQueue':
      return readerBeraPaw
    case 'treehouseRedemptionQueue':
      return readerTreehouseRedemption
    case 'eventsOnly':
    case 'noQueue':
    case 'unverified':
      return readerEmpty
  }
}
